import { Chains } from 'api/types/httpsTypes/d-wallets';

export function buildSubscriptionStore() {
  const store: { [key: string]: boolean } = {};
  return {
    isSubscribed: (key: string) => store[key] || false,
    subscribe: (key: string) => (store[key] = true),
    unsubscribe: (key: string) => (store[key] = false),
  };
}

// modules/tw-chart/datafeed/subscriptions.ts
type SubscriptionParams = {
  chain: Chains;
  poolAddress: string;
  interval: string;
  currency: string;
  isPriceShown: boolean;
};

type Subscription = {
  params: SubscriptionParams;
  callback: (bar: any) => void;
};

const setSubscriptions = new Map<string, Subscription>();

export const twSubscriptions = {
  subscribe: (
    uid: string,
    params: SubscriptionParams,
    callback: (bar: any) => void
  ) => {
    setSubscriptions.set(uid, { params, callback });
  },

  unsubscribe: (uid: string) => {
    setSubscriptions.delete(uid);
  },

  forMatching: (
    match: SubscriptionParams,
    fn: (cb: (bar: any) => void) => void
  ) => {
    setSubscriptions.forEach(({ params, callback }) => {
      if (
        params.chain === match.chain &&
        params.poolAddress === match.poolAddress &&
        params.interval === match.interval &&
        params.currency === match.currency
      ) {
        fn(callback);
      }
    });
  },
};
